import React, { useState, useEffect, useCallback } from "react";
import { get, post } from "../services/ApiService";
import { useChatCounts } from "../context/ChatCountsContext";
import { notification } from "antd";

import { Button } from "antd";
import { SyncOutlined } from "@ant-design/icons";
import toast from "react-hot-toast";
import NotificationDropdown from "./NotificationDropdown";

const NOTIFICATION_REFRESH_EVENT = "chat_notifications_updated";

const Notifications = () => {
  const { refresh: refreshCounts } = useChatCounts();
  const [gslNotifications, setGslNotifications] = useState([]);
  const [pendingPmedNotifications, setPendingPmedNotifications] = useState([]);
  const [completePmedNotifications, setCompletePmedNotifications] = useState(
    []
  );
  const [isRefreshing, setIsRefreshing] = useState(false);

  const fetchNotifications = useCallback(async () => {
    try {
      setIsRefreshing(true);
      setGslNotifications([]);
      setPendingPmedNotifications([]);
      setCompletePmedNotifications([]);
      const res = await get("api/notifications");

      setIsRefreshing(false);
      if (res.success) {
        setGslNotifications(res.gslNotifications);
        setPendingPmedNotifications(res.pendingPmedNotifications);
        setCompletePmedNotifications(res.completePmedNotifications);
        refreshCounts();
      }
    } catch (error) {
      setIsRefreshing(false);
      console.error("Error fetching notifications:", error);
    }
  }, [refreshCounts]);

  useEffect(() => {
    fetchNotifications();
    const interval = setInterval(fetchNotifications, 60000);
    return () => clearInterval(interval);
  }, [fetchNotifications]);

  useEffect(() => {
    const handleNotificationRefresh = () => {
      fetchNotifications();
    };

    window.addEventListener(NOTIFICATION_REFRESH_EVENT, handleNotificationRefresh);
    return () =>
      window.removeEventListener(
        NOTIFICATION_REFRESH_EVENT,
        handleNotificationRefresh
      );
  }, [fetchNotifications]);
  const deleteSingleNotifications = async (ticketNo, type) => {
    try {
      const payload = { ticketNo, type };
      const res = await post(`api/notifications/delete/single`, payload);

      if (res.success) {
        await fetchNotifications();
        window.dispatchEvent(new Event(NOTIFICATION_REFRESH_EVENT));
        notification.success({
          message: "Success",
          description: "Notification marked as read successfully.",
        });
      } else {
        notification.error({
          message: "Error",
          description: "Failed to mark notification as read.",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Failed to mark notification as read.",
      });
      console.error("Error deleting notification:", error);
    }
  };

  const handleRefresh = async () => {
    await fetchNotifications();
    toast.success("Refreshed");
  };
  return (
    <>
      <Button
        type="text"
        icon={<SyncOutlined spin={isRefreshing} />}
        onClick={handleRefresh}
        disabled={isRefreshing}
        className="mr-2"
      >
        {isRefreshing ? "Refreshing..." : "Refresh"}
      </Button>
      <NotificationDropdown
        notifications={gslNotifications}
        icon="far fa-comment-dots"
        title="Gsl order notifications"
        deleteSingleNotifications={deleteSingleNotifications}
      />
      <NotificationDropdown
        notifications={pendingPmedNotifications}
        icon="far fa-comments"
        title="Pending P order notifications"
        deleteSingleNotifications={deleteSingleNotifications}
      />
      <NotificationDropdown
        notifications={completePmedNotifications}
        icon="far fa-envelope"
        title="Complete order notifications"
        deleteSingleNotifications={deleteSingleNotifications}
      />

      {/* <NotificationDropdown
              notifications={notifications}
              type="AssessmentComplete"
              isMark={isMark}
              icon="far fa-bell"
              title="Assessment complete notifications"
              deleteNotifications={deleteNotifications}
              deleteSingleNotifications={deleteSingleNotifications}
            /> */}
    </>
  );
};

export default Notifications;
